import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import Button from '../Button/Button';
import useStyles from './KeepShopping.styles';
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';
import { Box, useTheme } from '@mui/material';
import { useRouter } from 'next/router';
import { SiteContext } from '../../utils/common';
const KeepShopping = ({ fullWidth, handleButtonClick, buttonPlacement, component }) => {
    const { isFlyingFlowers } = useContext(SiteContext);
    const theme = useTheme();
    const router = useRouter();
    const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpoints.values.sm}px)` });
    const { classes } = useStyles();
    const basketClassNames = buttonPlacement === 'BOTTOM' ? classes.displayMobile : classes.displayDesktop;
    const handleKeepShoppingButtonClick = () => {
        handleButtonClick && handleButtonClick();
        const url = isFlyingFlowers ? 'category/flowers/all-flower-bouquets' : '/category/flower-arrangements';
        router.push(url);
    };
    return (_jsx(Box, { className: clsx(fullWidth ? classes.fullWidthContainer : '', classes.addMarginTop, component === 'BASKET' ? basketClassNames : ''), "data-testid": "keep-shopping-button", children: _jsx(Button, { title: "Keep shopping", thin: true, variant: isFlyingFlowers || buttonPlacement === 'BOTTOM' || isMobile ? 'secondary' : 'tertiary', onClick: handleKeepShoppingButtonClick, className: isMobile ? classes.mobileButton : '' }) }));
};
export default KeepShopping;
